<template>

    <div id="close-session-alert-modal" class="close-session-alert-modal modal fade" tabindex="1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-pdv-small modal-dialog-centered">
            <div class="modal-content">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>

                <div class="main-content">
                    <h3>TU SESIÓN CERRARÁ EN</h3>

                    <span class="fs-99 lh-102 mb-0">{{localPageTimer | onlySeconds}}</span>

                    <span class="fs-20 lh-23">SEGUNDOS</span>

                    <p>¿Necesitas más tiempo?</p>

                    <a @click="onContinue" href="#" data-dismiss="modal" class="btn-pdv-primary ">SI, CONTINUAR EN PDV</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {TIME_LOCAL_PAGE_TIMER} from '../../constants'
    import moment from 'moment';
    import {mapState,mapActions,mapMutations} from 'vuex';
    export default {
        computed : {
            ...mapState(['localPageTimer'])
        },
        methods : {
            ...mapMutations(['setTimerPageExpired']),
            onContinue(){
                this.setTimerPageExpired(true)
            }
        },
        filters : {
            onlySeconds(time){
                return moment(time,'mm:ss').format('ss')
            }
        }
    }
</script>

<style scoped lang="scss">
    .close-session-alert-modal {
        @include media-breakpoint-down(sm){
            padding-right: 0 !important;
        }
        .modal-pdv-small {
            max-width: 481px;
            .modal-content{
                background: #313541;
                padding: 48px 40px;
                border-radius: 1px;
                box-shadow: 0 0 12px 3px #00000038;
                
                button.close{
                    position: absolute;
                    top: 15px;
                    right: 15px;
                    opacity: 1;
                    span{
                        font-size: 30px;
                        color: #fff;
                    }
                }
                .main-content{
                    text-align: center;
                    h3{
                        font-size: 20px;
                        line-height: 23px;
                        margin-bottom: 33px;
                        color: #fff;
                        @include alternative-bold;
                    }
                    span{
                        color: #fff;
                        @include font-extra-bold-regular;
                        display: block;
                    }

                    p{
                        font-size: 18px;
                        line-height: 26px;
                        margin-top: 31px;
                        margin-bottom: 17px;
                        color: #fff;
                        @include alternative-regular;
                    }
                    .btn-pdv-primary{
                        padding: 14px 40px;
                    }
                }
            }

        }
    }

</style>